import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Attach JWT token to every request if present
api.interceptors.request.use(config => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 403
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 403) {
      localStorage.removeItem('adminToken');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default api;

// ── Products ──────────────────────────────────────────────────────────────────
export const getProducts = (params) => api.get('/products', { params });
export const getProduct = (id) => api.get(`/products/${id}`);
export const getAdminProducts = () => api.get('/products/admin/all');
export const getAdminProduct = (id) => api.get(`/products/admin/${id}`);
export const createProduct = (formData) => api.post('/products', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateProduct = (id, formData) => api.put(`/products/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteProduct = (id) => api.delete(`/products/${id}`);
export const syncCartActivity = (data) => api.post('/cart/sync', data);
export const syncSavedItems = (data) => api.post('/saved/sync', data);

// ── Orders ────────────────────────────────────────────────────────────────────
export const getOrders = (params) => api.get('/orders', { params });
export const getOrder = (id) => api.get(`/orders/${id}`);
export const lookupOrder = (orderNumber) => api.get(`/orders/lookup/${orderNumber}`);
export const updateOrderStatus = (id, status, notes) => api.put(`/orders/${id}/status`, { status, notes });
export const getOrderStats = () => api.get('/orders/stats/summary');

// ── Payments ──────────────────────────────────────────────────────────────────
export const createStripeIntent = (data) => api.post('/payments/stripe/create-intent', data);
export const confirmStripeOrder = (data) => api.post('/payments/stripe/confirm', data);
export const createPayPalOrder = (data) => api.post('/payments/paypal/create-order', data);
export const capturePayPalOrder = (data) => api.post('/payments/paypal/capture', data);
export const previewPaymentTotals = (data) => api.post('/payments/preview-totals', data);

// ── Shipping ──────────────────────────────────────────────────────────────────
export const getShippingRates = (data) => api.post('/shipping/rates', data);
export const buyShippingLabel = (data) => api.post('/shipping/buy', data);
export const trackShipment = (trackingNumber) => api.get(`/shipping/track/${trackingNumber}`);

// ── Support ───────────────────────────────────────────────────────────────────
export const submitTicket = (data) => api.post('/support', data);
export const getTickets = (params) => api.get('/support', { params });
export const replyTicket = (id, data) => api.put(`/support/${id}/reply`, data);
export const lookupTicket = (ticketNumber) => api.get(`/support/lookup/${ticketNumber}`);

// ── Promotions ────────────────────────────────────────────────────────────────
export const getActivePromotions = () => api.get('/promotions/active');
export const getPromotions = () => api.get('/promotions');
export const createPromotion = (data) => api.post('/promotions', data);
export const updatePromotion = (id, data) => api.put(`/promotions/${id}`, data);
export const deletePromotion = (id) => api.delete(`/promotions/${id}`);

// ── Admin Security ────────────────────────────────────────────────────────────
export const changeAdminCredentials = (data) => api.post('/auth/change-credentials', data);
